import { Link } from 'react-router-dom';
import { EMAIL_CONTATO } from '../config';
import WhatsappFlutuante from '../components/WhatsappFlutuante';
import Logo from '../components/Logo';

export default function Privacidade() {
  return (
    <div>
      <nav className="lp-nav">
        <Link to="/"><Logo /></Link>
        <Link to="/" className="btn sec sm">← Voltar</Link>
      </nav>

      <div className="doc">
        <h1>Política de Privacidade</h1>
        <p style={{ color: 'var(--texto-suave)' }}>Última atualização: setembro de 2026</p>

        <p>Esta Política descreve como a <strong>Manux Service</strong> (CNPJ 48.634.165/0001-41) coleta, usa e protege
        os dados pessoais tratados na plataforma, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).</p>

        <h2>1. Dados que coletamos</h2>
        <ul>
          <li><strong>Cadastro:</strong> nome, e-mail, telefone/WhatsApp, empresa e senha (armazenada de forma criptografada).</li>
          <li><strong>Uso do sistema:</strong> ordens de serviço, ativos, unidades, materiais e registros de atividade (logs).</li>
          <li><strong>Dados técnicos:</strong> endereço IP e informações de acesso para segurança.</li>
        </ul>

        <h2>2. Localização (GPS)</h2>
        <p><strong>O aplicativo móvel Manux Service acessa e coleta dados de localização do dispositivo (Location data).</strong>{' '}
        Enquanto o técnico está com o aplicativo aberto — e também em segundo plano, quando essa permissão é concedida —
        coletamos a localização em tempo real (GPS) do dispositivo para:</p>
        <ul>
          <li>Registrar o local de abertura, execução e finalização de cada ordem de serviço;</li>
          <li>Permitir que o gestor acompanhe, em tempo real, onde a equipe de campo está (rastreamento de técnicos).</li>
        </ul>
        <p>A localização não é usada para nenhuma outra finalidade, não é vendida e é compartilhada apenas dentro da própria empresa
        contratante (o gestor da equipe), nunca com terceiros externos.</p>

        <h2>3. Como usamos os dados</h2>
        <ul>
          <li>Prover e operar a plataforma de gestão operacional e automação.</li>
          <li>Autenticar usuários e manter a segurança das contas.</li>
          <li>Enviar comunicações operacionais (ex.: notificações de OS via WhatsApp, quando habilitado).</li>
          <li>Melhorar o serviço e cumprir obrigações legais.</li>
        </ul>

        <h2>4. Isolamento e compartilhamento</h2>
        <p>Os dados de cada empresa são mantidos isolados em seu próprio ambiente. Não vendemos dados pessoais.
        O compartilhamento ocorre apenas com provedores essenciais à operação (ex.: hospedagem e envio de mensagens) ou por obrigação legal.</p>

        <h2>5. Seus direitos (LGPD)</h2>
        <p>Você pode solicitar acesso, correção, portabilidade, anonimização ou exclusão dos seus dados, além de revogar consentimentos.
        Para exercer esses direitos, entre em contato pelos canais abaixo.</p>

        <h2>6. Segurança</h2>
        <p>Adotamos medidas técnicas e organizacionais para proteger os dados, incluindo criptografia de senhas, controle de acesso por perfil
        e comunicação via HTTPS. Nenhum dado é excluído fisicamente sem registro (exclusão lógica).</p>

        <h2>7. Retenção</h2>
        <p>Mantemos os dados pelo tempo necessário à prestação do serviço e ao cumprimento de obrigações legais. Após esse período, os dados podem ser anonimizados ou eliminados.</p>

        <h2>8. Contato</h2>
        <p>Manux Service — CNPJ 48.634.165/0001-41. Dúvidas sobre privacidade? Fale com a gente pelo WhatsApp ou pelo e-mail <a href={`mailto:${EMAIL_CONTATO}`}>{EMAIL_CONTATO}</a>.</p>

        <p style={{ marginTop: 30 }}><Link to="/termos">Ver também: Termos de Uso →</Link></p>
      </div>
      <WhatsappFlutuante />
    </div>
  );
}
